import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {

  constructor() {}

  ngOnInit() {}

}



// WEBPACK FOOTER //
// /Users/jonshilton/Projects/nick-smith-app/src/app/pages/services/services.component.ts